import {
  DICTIONARIES_SORT_OPTIONS,
  DICTIONARIES_FILTER_OPTIONS,
} from 'constants/dictionariesOptions';
import initialListState from 'store/hoReducers/paginatedList/initialState';

const initialState = {
  ...initialListState,
  list: {
    ...initialListState.list,
    sortOptions: DICTIONARIES_SORT_OPTIONS,
    filterOptions: DICTIONARIES_FILTER_OPTIONS,
    paginationOptions: {
      ...initialListState.list.paginationOptions,
      archived: '',
      imported_from_xpack: '',
    },
    filterParams: {},
  },
};

export default initialState;
